import styles from './ScrollToTop.module.scss'
import React from 'react'
import { useScrollToTop } from '@/utils/hooks/useScrollToTop'
import classNames from 'classnames'

type Props = {}

const ScrollToTop = (props: Props) => {
  const { scrollToTop, showScrollToTop } = useScrollToTop()

  const classes = classNames({
    [styles.component]: true,
    [styles.show]: showScrollToTop,
  })

  return (
    <div className={classes} onClick={scrollToTop} />
  )
}

export default ScrollToTop